import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';

import css from './LandingPage.module.css';

//Static assets
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import SectionHero from './SectionHero/SectionHero';
import SectionCategory from './Sections/SectionCategory';
import SectionExplore from './Sections/SectionExplore';
import SectionFeaturedSeller from './Sections/SectionFeaturedSeller';
import SectionCTA from './Sections/SectionCTA';
import SectionWhySoulSearch from './Sections/SectionWhySoulSearch';
import SectionTestimonials from './Sections/SectionTestimonials';
import SectionBlog from './Sections/SectionBlog';
import SectionSingleBlog from './Sections/SectionSingleBlog';
import SectionBlogs from './Sections/SectionBlogs';
import SectionHowItWorks from './Sections/SectionHowItWorks';
import SectionFeaturedBrand from './Sections/SectionFeaturedBrand';
import SectionShopByCategory from './Sections/SectionShopByCategory';

export const LandingPageComponent = props => {
  const { intl, scrollingDisabled, history, viewport, currentUser, listings } = props;

  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;

  const config = useConfiguration();

  const marketplaceName = config.marketplaceName;

  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({
    id: 'LandingPage.schemaDescription',
  });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  const useHistoryPush = (page, params = {}, search = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, search));
  };

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        // isHeaderWithoutBg={true}
        topbar={<TopbarContainer viewport={viewport} />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <SectionHero
            listings={listings}
            intl={intl}
            useHistoryPush={useHistoryPush}
            isMobileLayout={isMobileLayout}
            isLandingPage={true}
          />
          <SectionShopByCategory      intl={intl} useHistoryPush={useHistoryPush} isMobileLayout={isMobileLayout} />
          <SectionHowItWorks
            intl={intl}
            isMobileLayout={isMobileLayout}
            useHistoryPush={useHistoryPush}
          />
          {/* <SectionFeaturedBrand isMobileLayout={isMobileLayout} viewport={viewport} intl={intl} /> */}
          <SectionCategory
            isMobileLayout={isMobileLayout}
            intl={intl}
            viewport={viewport}
            useHistoryPush={useHistoryPush}
          />
          <SectionExplore
            isMobileLayout={isMobileLayout}
            intl={intl}
            viewport={viewport}
            useHistoryPush={useHistoryPush}
            listings={listings}
          />

          {/* <SectionFeaturedSeller
            isMobileLayout={isMobileLayout}
            intl={intl}
            viewport={viewport}
            useHistoryPush={useHistoryPush}
            listings={listings}
            isPractionarListingCard={true}
          /> */}

          {/*  <SectionWhySoulSearch viewport={viewport} />
          <SectionTestimonials currentUser={currentUser} intl={intl} />
          <SectionCTA viewport={viewport} />
          <SectionBlog currentUser={currentUser} intl={intl} /> */}
          {/* <SectionSingleBlog currentUser={currentUser} intl={intl} /> */}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { currentPageResultIds } = state.LandingPage;
  const listings = getListingsById(state, currentPageResultIds);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    listings,
  };
};

const LandingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  ),
  withViewport,
  injectIntl
)(LandingPageComponent);

export default LandingPage;
